import { Component, OnInit } from '@angular/core';
import { FormService } from '../services/form.service';
import { UntypedFormGroup, Validators } from "@angular/forms";
import { ApiService } from "../services/api.service";
import { animate, state, style, transition, trigger } from "@angular/animations";
import { environment } from "../../environments/environment";
import Bugsnag from "@bugsnag/js";

export interface Question {
	name: string,
	title: string,
	question: string,
	class: string,
	extra_1_type?: number,
	extra_1_question?: string,
	extra_1_options?: string,
	extra_1_class?: string,

	extra_2_type?: number,
	extra_2_question?: string,
	extra_2_options?: string,
	extra_2_class?: string,

	key: number;

	double?: number,
}
export type Questions = Question[];

@Component( {
	selector: 'app-thank-you',
	templateUrl: './thank-you.component.html',
	styleUrls: ['./thank-you.component.scss'],
	animations: [
		trigger('slideInOut', [
			transition(':enter', [
				style({opacity: 0}),
				animate('300ms ease-in-out', style({opacity: 1}))
			]),
			transition(':leave', [
				style({opacity: 1}),
				animate('300ms ease-in-out', style({opacity: 0}))
			]),
		]),
		trigger('slide', [
			state('1', style({left: '0'})),
			state('2', style({left: '-100%'})),
			state('3', style({left: '-200%'})),
			state('4', style({left: '-300%'})),
			state('5', style({left: '-400%'})),
			state('6', style({left: '-500%'})),
			state('7', style({left: '-600%'})),
			state('8', style({left: '-700%'})),
			state('9', style({left: '-800%'})),
			state('10', style({left: '-900%'})),
			transition('* => *', animate('550ms ease-out')),
		])
	]
} )
export class ThankYouComponent implements OnInit {

	public thirdPartyForm !: UntypedFormGroup
	formGroupName : string = 'thirdPartyForm'
	private debugCountDownAndRedirect : boolean = false;
	public loadingAnimationBeforeRedirecting : boolean = false;
	public currentStep: number = 1;

	constructor( public formService: FormService,
	             private apiService: ApiService ) {
	}

	ngOnInit(): void {

		this.thirdPartyForm = this.formService.thirdPartyForm as UntypedFormGroup;

		// == Debugging questions ==
		if( this.formService.debugThirdPartyQuestions && ! environment.production ) {

			this.formService.questions = [
				'currency_exchange',
				'utilities',
				'real_estate',
				'health_insurance'
			];
			this.formService.setupThirdPartyForm();
		}

		if( this.debugCountDownAndRedirect && ! environment.production ) {

			// This requires formService.formActive to be on false as well
			// This does not work together with the third party questions
			setTimeout( () => {

				this.formService.token = 'testing';
				this.formService.countDownAndRedirect();
			}, 1000 );
		}

		// == END DEBUGGING == //
	}

	waitAndGoToDashboard( event:any ) {

		// Stop linking
		event.preventDefault();

		// Wait time 1.5s
		var waitTime = 1500;

		// Add loader in button
		this.loadingAnimationBeforeRedirecting = true;

		// Wait
		setTimeout( () => {
			window.location.href = this.formService.dashboardUrl;
		}, waitTime );
	}
}
